// 手机号
export const checkIphone = async (value: string) => {
  let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

  if (value) {
    if (!myreg.test(value)) {
      return Promise.reject('请填写正确的手机号');
    } else {
      return Promise.resolve();
    }
  }
};
// 邮箱
export const validateEmail = async (_, value: string) => {
  let myreg = new RegExp(
    '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$',
  );
  if (!myreg.test(value)) {
    return Promise.reject('请填写正确的邮箱');
  } else {
    return Promise.resolve();
  }
};

// 邮编
export const checkApplyPost = async (_, value: string) => {
  let myreg = /^[0-9][0-9]{5}$/;
  if (value) {
    if (!myreg.test(value)) {
      return Promise.reject('请填写正确的邮编');
    } else {
      return Promise.resolve();
    }
  }
};

export function checkIphoneFn(value: string): boolean {
  let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  return myreg.test(value);
}

export function validateEmailFn(value: string): boolean {
  let myreg = new RegExp(
    '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$',
  );
  return myreg.test(value);
}
// 邮编
export function checkApplyPostFn(value: string): boolean {
  let myreg = /^[1-9][0-9]{5}$/;
  return myreg.test(value);
}
// 是否是图片
export function isImg(value: string): boolean {
  const imgFormartLsit = ['png', 'jpeg', 'jpg'];
  let item = value.toLowerCase().split('.').pop();
  return imgFormartLsit.indexOf(item) != -1;
}
// descriptions无数据展示-
export function dataFormat(params) {
  if (params == '' || params == undefined || params == null) {
    return '-';
  } else {
    return params;
  }
}

export function isPdf(value: string): boolean {
  const imgFormartLsit = ['pdf'];
  let item = value.toLowerCase().split('.').pop();
  return imgFormartLsit.indexOf(item) != -1;
}

export function isWord(value: string): boolean {
  const imgFormartLsit = ['doc', 'docx', 'word'];
  let item = value.toLowerCase().split('.').pop();
  return imgFormartLsit.indexOf(item) != -1;
}

// 身份证号
export const checkIdCardNo = async (_, value: string) => {
  console.log("checkIdCardNo---", value);
  if (value && checkIdCardNoFunc(value)) {
    console.log("结果是yes---");
    return Promise.resolve();
  } else {
    console.log("结果是NO---");
    return Promise.reject('请填写正确的身份证号');
  }
};

// 身份证号
export function checkIdCardNoFunc(value: string): boolean {
  let myreg = /^[1-9]\d{5}(19|20)\d{2}(0\d|1[0-2])([012]\d|3[01])\d{3}[0-9X]$/;
  return !value ? false : myreg.test(value);
};


export const checkTxtIsNum = async (_, value: string) => {
  if (value && checkTxtIsNumFunc(value)) {
    return Promise.resolve();
  } else {
    return Promise.reject('请填写正确的身份证号');
  }
};

export function checkTxtIsNumFunc(value: string): boolean {
  let regex = /^\d+$/;
  return value ? regex.test(value) : false
}




//根据身份证号获得出生年月
export function getBirthdayByIdCard(idCard) {
  if (idCard.length === 15) {
    return ['19' + idCard.substr(6, 2), idCard.substr(8, 2), idCard.substr(10, 2)].join('-')
  } else if (idCard.length === 18) {
    return [idCard.substr(6, 4), idCard.substr(10, 2), idCard.substr(12, 2)].join('-')
  }

  return ''
}

//根与身份证号获取性别
export function getSexByIdCard(idCard) {
  let index = '';
  if (idCard.length === 15) {
    index = ['女', '男'][idCard.substr(14, 1) % 2]
  } else if (idCard.length === 18) {
    index = ['女', '男'][idCard.substr(16, 1) % 2]
  }
  return index == '男' ? '11' : '12'
}

export function getAgeByIDCard(idCard) {
  // const birthYear = idCard.substring(6, 10);
  // const currentYear = new Date().getFullYear();
  // const age = currentYear - parseInt(birthYear);
  // return age;


  let birthday = idCard.substring(6, 14); // 提取生日信息
  let currentDate = new Date(); // 获取当前日期

  let year = parseInt(birthday.substr(0, 4)); // 提取年份部分并转换为整型
  let month = parseInt(birthday.substr(4, 2)) - 1; // 月份需要减去1，因为月份在JavaScript中是从0开始计数的
  let day = parseInt(birthday.substr(6, 2)); // 提取日期部分并转换为整型

  let ageStartDate = new Date(year, month, day); // 创建生日日期对象
  let timeDiff = Math.abs(currentDate.getTime() - ageStartDate.getTime()); // 计算时间差值
  let ageInDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); // 将时间差值转换为天数

  return Math.floor(ageInDays / 365); // 返回年龄

}


export function getFileNameByUrl(url:string){
  if(!url || url && url.length == 0)return '';
  let pathname = new URL(url).pathname;
  let index = url.lastIndexOf('/');
  return (-1 !== index) ? pathname.substring(index + 1) : pathname;
}